import { cn } from '@/lib/utils';

/**
 * CharacterCount — the small "1,700 / 2,000" hint under a bounded text field.
 *
 * Pairs with a `maxLength` on the field: the browser stops the input at the limit, and this
 * explains WHY a long paste stopped instead of letting the tail vanish silently. Always shown,
 * so the limit is known before anyone runs into it.
 */
export function CharacterCount({ value, max, className }: { value: string; max: number; className?: string }) {
  const used = value.length;
  const atLimit = used >= max;
  return (
    <p
      aria-live="polite"
      className={cn('m-0 text-right text-[11.5px]', atLimit ? 'text-state-error-text' : 'text-muted', className)}
    >
      {used.toLocaleString('en-US')} / {max.toLocaleString('en-US')}
      {atLimit ? ' · limit reached' : ''}
    </p>
  );
}
